// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'flag-solid';

export const Component = () => (
  <path d='M4.958.48v23.564c0 .335-.144.479-.48.479-.334 0-.478-.144-.478-.48V.48c0-.335.144-.478.479-.478.335 0 .479.143.479.478Zm15.23-.478H5.963v11.78h14.224c.432 0 .767-.143 1.054-.43.288-.288.432-.623.432-1.054V1.485c0-.431-.144-.766-.432-1.054A1.408 1.408 0 0 0 20.188 0v.002Z' />
);

export const viewBox = '0 0 25 25';
